export enum DropdownSize {
  SMALL = "small",
  LARGE = "large",
}

export enum DropdownType {
  BEST_PRACTICES = "bestPractices",
  CONSULTANT = "consultant",
  COUNTRY = "country",
  CERTIFICATION = "certification",
  MATURITY_MODEL = "maturityAssessments",
  REGION = "region",
  TOPICS = "topics",
  CONTENT_TYPE = "contentType",
}

export enum DropdownButtonType {
  RADIO = "radio",
  CHECKBOX = "checkbox",
}

export enum DropdownMatchesType {
  ID = "id",
  SLUG = "slug",
  TITLE = "title",
  UID = "uid",
}